export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              影视资讯速递，第一时间了解平台更新与热门内容
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 border-l-2 border-background-200 space-y-8">
              {/* Update 1 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500"></div>
                <span className="text-xs text-primary-500 font-medium whitespace-nowrap">今天 14:30</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">《星际征途》蓝光版正式上线</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">年度科幻巨制4K蓝光版本已全面上线，支持HDR10+和杜比全景声，带来沉浸式视听盛宴。</p>
              </div>

              {/* Update 2 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-accent-500"></div>
                <span className="text-xs text-accent-600 font-medium whitespace-nowrap">今天 10:15</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">热播韩剧《恋之樱花季》更新至第12集</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">浪漫甜宠韩剧最新一集已上线，每周三、周五同步韩国播出，中文字幕即时更新。</p>
              </div>

              {/* Update 3 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-background-400"></div>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">昨天 20:00</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">播放器全面升级：智能码率切换上线</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">全新智能自适应码率技术已部署完成，根据网络状况自动调节清晰度，确保流畅不缓冲的观影体验。</p>
              </div>

              {/* Update 4 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-background-400"></div>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">昨天 16:45</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">纪录片专区新增《地球脉动III》全集</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">BBC经典自然纪录片系列第三季全8集已上线，4K超清画质带您领略地球奇观。</p>
              </div>

              {/* Update 5 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-background-400"></div>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">7月28日</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">暑期档专题「科幻盛宴」正式上线</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">精选20部高分科幻巨制，从经典到最新院线大片一网打尽，暑期观影不剧荒。</p>
              </div>

              {/* Update 6 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-background-400"></div>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">7月27日</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">《暗夜追踪》票房突破30亿，平台独家幕后花絮上线</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">悬疑动作大片票房大卖，主演专访和拍摄花絮现已独家登陆西瓜影视。</p>
              </div>

              {/* Update 7 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-background-400"></div>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">7月26日</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">移动端APP v3.2版本发布</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">新增离线缓存、画中画播放和夜间模式，移动观影体验全面升级，iOS和Android同步更新。</p>
              </div>

              {/* Update 8 */}
              <div className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-background-400"></div>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">7月25日</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mt-1">悬疑剧场「烧脑特辑」10部高分好剧推荐</h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">精选国内外高分悬疑剧集，反转不断的高能剧情，挑战你的推理极限。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}